export enum products {
  get = "products/get",
  post = "products/post",
  put = "products/put",
  delete = "products/delete",
}

//Login Paths
export enum LoginPaths {
  login = "auth",
  getNewToken = "auth/newToken",
}

//EmployeVerification Paths
export enum EmployeVerificationPaths {
  basePath = "security-service-employee-verification",
  generateOtp = EmployeVerificationPaths.basePath,
  changePassword = EmployeVerificationPaths.basePath,
  unlockUser = EmployeVerificationPaths.basePath + "/unlockUser",
}
export enum OptionsMenu {
  options = "security-service-options-menus",
}

export enum Menus {
  menu = "security-service-menus",
}

//Employe Paths
export enum EmployePaths {
  basePath = "security-service-employees",
  get = EmployePaths.basePath,
  post = EmployePaths.basePath,
  put = EmployePaths.basePath,
  delete = EmployePaths.basePath,
  getByBranch = EmployePaths.basePath + "/employesByBranch/",
  blockUser = EmployePaths.basePath + "/blockEmploye/",
}

export enum EmployereportPaths {
  basePath = "security-service-employees",
  getEmploye = EmployereportPaths.basePath+ "/findEmployeByState/",
  getByBranch = EmployereportPaths.basePath + "/employesByBranch/",
  blockUser = EmployereportPaths.basePath + "/blockEmploye/",
}

//UserType Paths
export enum UserTypePaths {
  basePath = "administration-service-user-types",
  get = UserTypePaths.basePath,
  post = UserTypePaths.basePath,
  put = UserTypePaths.basePath,
  delete = UserTypePaths.basePath,
}

//Roles Paths
export enum RolesPaths {
  basePath = "security-service-roles",
  get = RolesPaths.basePath,
  post = RolesPaths.basePath,
  put = RolesPaths.basePath,
  delete = RolesPaths.basePath,
  getByCompany = RolesPaths.basePath + "/findAllByCompany",
}
//Customers Paths
export enum CustomerTypesPaths {
  basePath = "administration-service-customer-types",
  get = CustomerTypesPaths.basePath,
  post = CustomerTypesPaths.basePath,
  put = CustomerTypesPaths.basePath,
  delete = CustomerTypesPaths.basePath,
}

//CustomersTypes Paths
export enum CustomerPaths {
  basePath = "administration-service-customers",
  get = CustomerPaths.basePath,
  post = CustomerPaths.basePath,
  put = CustomerPaths.basePath,
  delete = CustomerPaths.basePath,
}
//Company Paths
export enum CompanyPaths {
  basePath = "administration-service-companies",
  get = CompanyPaths.basePath,
  post = CompanyPaths.basePath,
  put = CompanyPaths.basePath,
  delete = CompanyPaths.basePath,
}

//Branch Paths
export enum BranchPaths {
  basePath = "administration-service-branches",
  get = BranchPaths.basePath,
  getByCompany = BranchPaths.basePath + "/getByCompanyId",
  post = BranchPaths.basePath,
  patch = BranchPaths.basePath,
  delete = BranchPaths.basePath,
}

//Special Permission Paths
export enum SpecialPermissionPath {
  basePath = "security-service-specialpermissions",
  get = SpecialPermissionPath.basePath,
  post = SpecialPermissionPath.basePath,
  put = SpecialPermissionPath.basePath,
  delete = SpecialPermissionPath.basePath,
}

//Assigment Special Permission Paths
export enum AssigmentSpecialPermissionPath {
  basePath = "security-service-assignmentpermissionsspecial",
  get = "security-service-employees/employesByCompany/",
  post = AssigmentSpecialPermissionPath.basePath,
  put = AssigmentSpecialPermissionPath.basePath,
  delete = AssigmentSpecialPermissionPath.basePath,
}

//Permissions paths
export enum PermissionsPaths {
  basePath = "security-service-permissions",
  get = PermissionsPaths.basePath,
  post = PermissionsPaths.basePath,
  put = PermissionsPaths.basePath,
  delete = PermissionsPaths.basePath,
  getAllPermisesByUser = PermissionsPaths.basePath + "/findAllPermisesByUser/",
  getByRoleAndMenu = PermissionsPaths.basePath + "/findAllByRoleAndMenu/",
  postArrayPermissions = PermissionsPaths.basePath + "/assignPermissions",
  deleteArrayPermissions = PermissionsPaths.basePath + "/deletePermisos",
}

//Municipality path
export enum MunicipalityPath {
  basePath = "administration-service-municipalities",
  get = MunicipalityPath.basePath,
  post = MunicipalityPath.basePath,
  put = MunicipalityPath.basePath,
  delete = MunicipalityPath.basePath,
  findAllByDepartament = MunicipalityPath.basePath + "/findAllByDepartment/",
  getById = MunicipalityPath.basePath,
}

// Departament path
export enum DepartamentPath {
  basePath = "administration-service-departments",
  get = DepartamentPath.basePath,
  post = DepartamentPath.basePath,
  put = DepartamentPath.basePath,
  delete = DepartamentPath.basePath,
}

//Correlative Paths
export enum correlativePaths {
  basePath = "administration-service-correlatives",
  get = correlativePaths.basePath,
  post = correlativePaths.basePath,
  put = correlativePaths.basePath,
  delete = correlativePaths.basePath,
  getByBranch = correlativePaths.basePath + "/correlativesByBranch/",
}

export enum warehousePaths {
  basePath = "administration-service-warehouses",
  get = warehousePaths.basePath,
  post = warehousePaths.basePath,
  put = warehousePaths.basePath,
  delete = warehousePaths.basePath,
  getByBranch = warehousePaths.basePath + "/warehousesByBranch/",
}
//ProductClassification Paths
export enum ProductClassificationPaths {
  basePath = "administration-service-products-category",
  get = ProductClassificationPaths.basePath,
  post = ProductClassificationPaths.basePath,
  put = ProductClassificationPaths.basePath,
  delete = ProductClassificationPaths.basePath,
}

//Region Paths
export enum RegionsPaths {
  basePath = "administration-service-regions",
  get = RegionsPaths.basePath,
  post = RegionsPaths.basePath,
  put = RegionsPaths.basePath,
  delete = RegionsPaths.basePath,
}

export enum ProductPaths {
  basePath = "administration-service-providers",
  get = ProductPaths.basePath,
  post = ProductPaths.basePath,
  put = ProductPaths.basePath,
  delete = ProductPaths.basePath,
}

//* payments Types
export enum PaymentsTypesPaths {
  basePath = "purchases-service-payment-types",
  get = PaymentsTypesPaths.basePath,
  post = PaymentsTypesPaths.basePath,
  put = PaymentsTypesPaths.basePath,
  delete = PaymentsTypesPaths.basePath,
  getAllPaymentsTypes = PaymentsTypesPaths.basePath + "/activePaymentTypes",
}

//* Providers Bills
export enum ProvidersBillsPaths {
  basePath = "purchases-service-payable-accounts",
  getAvailable = ProvidersBillsPaths.basePath + "/availablePayableAccounts",
}

export enum PurchaseProvider {
  basePath = "purchases-service-providers",
  paymentToProvider = PurchaseProvider.basePath + "/paymentProvider",
}
//Brand Paths
export enum BrandsPaths {
  basePath = "administration-service-product-brands",
  get = BrandsPaths.basePath,
  post = BrandsPaths.basePath,
  put = BrandsPaths.basePath,
  delete = BrandsPaths.basePath,
}

//Products Paths
export enum ProductsPaths {
  basePath = "administration-service-products",
  get = ProductsPaths.basePath,
  post = ProductsPaths.basePath,
  put = ProductsPaths.basePath,
  delete = ProductsPaths.basePath,
  getByWarehouse = "purchases-service-inventory/availableWarehouseProducts",
}
export enum ProductExistReportPaths {
  basePath = "sales-service-inventory",
  post = ProductExistReportPaths.basePath + "/findStock",
}

export enum ProductExistPaths {
  basePath = "administration-service-products/stock",
  get = ProductExistPaths.basePath,
  post = ProductExistPaths.basePath,
  put = ProductExistPaths.basePath,
  delete = ProductExistPaths.basePath,
  getReport = ProductExistPaths.basePath ,
  getByWarehouse = "purchases-service-inventory/availableWarehouseProducts",
 
}

//Purchase Paths
export enum PurchasePaths {
  basePath = "purchasing-registration",
  post = PurchasePaths.basePath,
}

//providers Paths
export enum ProvidersPaths {
  basePath = "administration-service-providers",
  get = ProvidersPaths.basePath,
  post = ProvidersPaths.basePath,
}

//Provaider path
export enum ProviderPath {
  basePath = "administration-service-providers",
  get = ProviderPath.basePath,
  post = ProviderPath.basePath,
  put = ProviderPath.basePath,
  delete = ProviderPath.basePath,
  getById = ProviderPath.basePath,
}

//Purchase orders Paths
export enum PurchaseOrdersPaths {
  basePath = 'purchases-service-purchase-orders/findPurchases',
  post = PurchaseOrdersPaths.basePath,
  get = PurchaseOrdersPaths.basePath + "/findPurchases"
}


//Purchase orders Report Paths
export enum PurchaseOrdersReportsPaths {
  basePath = 'purchases-service-purchase-orders/findPurchases',
  post = PurchaseOrdersReportsPaths.basePath,
 
}


// * Warehouse Transfer Paths
export enum WarehouseTransferPaths {
  basePath = "purchases-service-inventory",
  post = WarehouseTransferPaths.basePath + "/warehouseTransfer",
}
//REport TRansfer
export enum WarehouseTransferReportPaths {
  basePath = "purchases-service-inventory",
  post = WarehouseTransferReportPaths.basePath + "/findTransfers",
}

//Quotes orders Paths
export enum QuotesOrdersPaths {
  basePath = 'sales-service-quotations',
  post = QuotesOrdersPaths.basePath,
}
export enum QuotesReportPaths {
  basePath = 'sales-service-quotations',
  post = QuotesReportPaths.basePath + "/findQuotes",
}


export enum SalesOrdersPaths {
  basePath = 'sales-service-sales',
  post = SalesOrdersPaths.basePath,
}


export enum SalesReportPaths {
  basePath = 'sales-service-sales',
  post = SalesOrdersPaths.basePath +"/findSales",
}

export enum SalesReportBybranchPaths {
  basePath = 'sales-service-sales',
  post = SalesReportBybranchPaths.basePath +"/findSalesBybranch",
}


//inventoryAdjustePath
export enum inventoryAdjustmenPath {
  basePath = "purchases-service-inventory",
  post = inventoryAdjustmenPath.basePath + "/adjustInventory",
  get =  warehousePaths.basePath,
  getProductInvetoryAd = ProductsPaths.basePath + "getProductsByWareHouse",
}


//inventoryAdjustePath
export enum availableReceible {
  basePath = 'sales-service-receible-accounts',
  get = availableReceible.basePath + '/availableReceibleAccounts',
  post = availableReceible.basePath + '/AccountStatements/',
}
export enum ReceibleReportPath {
  basePath = 'sales-service-receible-accounts',
  get = availableReceible.basePath + '/AccountStatements/',
}
export enum PaymentCustomer {
  basePath = 'sales-service-customers',
  paymentToCustomer = PaymentCustomer.basePath + '/paymentCustomer',
  
}

export enum FindPaymentCustomer {
  basePath = 'sales-service-customers',
  post = FindPaymentCustomer.basePath + '/findCustomerPyment',
}

export enum AdjustmenPath {
  basePath = "purchases-service-inventory",
  post = AdjustmenPath.basePath + "/findAdjustments",
}

//upload file

export enum UpluadImagenPath {
  basePath = "administration-service-upload-file",
  post = UpluadImagenPath.basePath ,
}

// Reports
export enum reportsServiceExistence {
  basePath = "reports-service-existence",
  post = reportsServiceExistence.basePath + "/daysInWarehouse"
}

export enum Reports {
  basePath = "reports-service-existence",
  getArticleReport = Reports.basePath + "/productsReport",
  baseParthReportClosing = "reports-service-general",
  getCashRegisterReport =  Reports.baseParthReportClosing + "/cortecajaReport"
}

export enum Dashboard {
  basePath = "reports-service-general",
  getDasboard = Dashboard.basePath + "/dashboardReport/",
  getDasboardAmount = Dashboard.basePath + "/dashboardAReport/",
}